import styled from "styled-components";
import { ActivateFeatureButton } from "./Button";
import {
    PortalCaption,
    PortalPanelHeader,
    PortalSectionTitle,
    PortalSurface,
    portalColors
} from "./BusinessPortalComponents";

export const SettingsPanelStack = styled.div`
    width: 100%;
    max-width: ${p => p.maxWidth || "100%"};
    margin: ${p => p.margin || "0"};
    margin-top: ${p => p.marginTop};
    margin-right: ${p => p.marginRight};
    margin-bottom: ${p => p.marginBottom};
    margin-left: ${p => p.marginLeft};
    display: flex;
    flex-direction: column;
    gap: ${p => p.gap || "1rem"};
    min-width: 0;
`;

export const SettingsPanelHeader = styled(PortalPanelHeader)`
    margin-bottom: ${p => p.marginBottom || "0"};
`;

export const SettingsPanelTitle = styled(PortalSectionTitle)`
    font-size: ${p => p.size || "1.25rem"};
    margin-bottom: 0.35rem;
`;

export const SettingsPanelCaption = styled(PortalCaption)`
    max-width: ${p => p.maxWidth || "48rem"};
`;

export const SettingsSectionCard = styled(PortalSurface)`
    margin-bottom: 0;
    box-shadow: ${p => p.shadow || "none"};
    padding: ${p => p.padding || "0"};
    overflow: ${p => p.overflow || "hidden"};
`;

export const SettingsSectionHeader = styled.div`
    min-height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: ${p => p.justifyContent || "flex-start"};
    gap: 0.75rem;
    padding: 0.9rem 1rem;
    box-sizing: border-box;
    border-bottom: 1px solid ${p => p.borderColor || portalColors.border};
    border-radius: ${p => p.borderRadius || "0"};
    background: ${p => p.background || portalColors.surface};
`;

export const SettingsSectionIcon = styled.img`
    width: ${p => p.size || "24px"};
    height: ${p => p.size || "24px"};
    object-fit: contain;
    flex: 0 0 auto;
`;

export const SettingsSectionTitle = styled.h3`
    color: ${p => p.color || portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.95rem;
    line-height: 1.25;
    font-weight: 800;
    margin: 0;
`;

export const SettingsSectionBody = styled.div`
    padding: ${p => p.padding || "1rem"};
    display: flex;
    flex-direction: column;
    gap: ${p => p.gap || "1rem"};
    background: ${p => p.background || portalColors.surface};
`;

export const SettingsInfoBox = styled.div`
    width: 100%;
    display: flex;
    align-items: ${p => p.alignItems || "flex-start"};
    justify-content: ${p => p.justifyContent || "space-between"};
    flex-wrap: wrap;
    gap: ${p => p.gap || "1rem"};
    padding: ${p => p.padding || "1rem"};
    background: ${p => p.background || portalColors.surfaceSoft};
    border: 1px solid ${p => p.border || portalColors.border};
    border-radius: ${p => p.radius || "12px"};
    box-sizing: border-box;

    @media (max-width: 760px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const SettingsBodyText = styled.p`
    color: ${p => p.color || portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: ${p => p.size || "0.875rem"};
    font-weight: ${p => p.weight || 500};
    line-height: 1.5;
    margin: 0;
    max-width: ${p => p.maxWidth || "54rem"};
`;

export const SettingsActionButton = styled(ActivateFeatureButton)`
    width: ${p => p.width || "auto"};
    min-width: ${p => p.minWidth || "16rem"};
    margin-top: ${p => p.marginTop || "0"};
    flex: 0 0 auto;
    text-decoration: none;

    @media (max-width: 620px) {
        width: 100%;
        min-width: 0;
    }
`;

export const SettingsDangerActionButton = styled.button`
    width: ${p => p.width || "auto"};
    min-width: ${p => p.minWidth || "14rem"};
    height: ${p => p.height || "42px"};
    padding: ${p => p.padding || "0 1rem"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: ${p => p.background || "#fff5f5"};
    color: ${p => p.color || "#ff3b3b"};
    border: ${p => p.border || "1px solid #ff3b3b"};
    border-radius: ${p => p.borderRadius || "8px"};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: ${p => p.weight || 700};
    line-height: 1.2;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        background: ${p => p.hoverBackground || "#ffeaea"};
        box-shadow: 0 10px 22px rgba(255, 59, 59, 0.12);
    }

    &:focus-visible {
        outline: 2px solid #171A22;
        outline-offset: 2px;
    }

    @media (max-width: 620px) {
        width: 100%;
        min-width: 0;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        &:hover:not(:disabled) {
            transform: none;
        }
    }
`;
